import React from 'react';

import { PricingTable } from 'src/components/DataDisplay';

import { CmsThemes, Locales } from 'src/lib/constants';

// data
import { metaData, pricingTableData } from 'src/store/en-gb/pricing';

import DefaultTemplate from 'src/templates/default';
import MainNavigationSpacer from 'src/components-v2/MainNavigationBar/MainNavigationSpacer';

export default ({ locale = Locales.EN_GB }) => {
  return (
    <DefaultTemplate {...metaData} locale={locale} cmsTheme={CmsThemes.WEB3}>
      <MainNavigationSpacer />
      <PricingTable {...pricingTableData} />
    </DefaultTemplate>
  );
};
